const form = document.querySelector('#form-appointment')
const sendBtn = document.querySelector('.button[type="submit"]')

const sendmail = () => {
    const formData = new URLSearchParams()

    for (const pair of new FormData(form)) {
        formData.append(pair[0], pair[1])
    }

    fetch('/atelier-b/sendmail.php', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        const msg = form.querySelector('.form-message')
        if (msg) msg.remove()

        if (data === 1) {
            form.insertAdjacentHTML('beforeend', '<div class="form-message form-message--floating form-message--success"><p>Vielen Dank! Ihre Nachricht wurde erfolgreich übermittelt.</p></div>')
        } else {
            form.insertAdjacentHTML('afterbegin', '<div class="form-message form-message--success"><p>Mail konnte nicht versendet werden.<br>Bitte versuchen Sie es erneut.</p></div>')
        }
    })
    .catch(error => {
        console.log(error)
    })
}

sendBtn.addEventListener('click', e => {
    if (form.checkValidity()) {
        e.preventDefault()
        gtag_report_conversion_form()
        sendmail()
    }
})

